const API_URL = import.meta.env.VITE_API_URL || "http://localhost:8000";

export interface WithdrawRequestBody {
  fund_id: string;
  user_address: string;
  amount: number;
}

export interface WithdrawResponse {
  cbor: string;
}

/**
 * Request unsigned transaction to withdraw fund shares
 * @param fundId - The fund's token name (identifier)
 * @param userAddress - User's wallet address
 * @param amount - Amount of fund tokens to withdraw (must be multiple of fund_factor)
 * @returns Unsigned transaction CBOR
 */
export async function withdrawFromFund(
  fundId: string,
  userAddress: string,
  amount: number
): Promise<string> {
  const url = `${API_URL}/withdraw?address=${encodeURIComponent(userAddress)}`;

  const requestBody: WithdrawRequestBody = {
    fund_id: fundId,
    user_address: userAddress,
    amount: amount,
  };

  console.log("Withdraw request:", { fundId, userAddress, amount });

  const response = await fetch(url, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error("Withdraw API error:", errorText);
    throw new Error(
      `Withdraw API error: ${response.status} - ${errorText}`
    );
  }

  const data: WithdrawResponse = await response.json();
  console.log("Withdraw response CBOR length:", data.cbor.length);
  return data.cbor;
}
